let NODE_ENV = process.env.NODE_ENV

export function shareShortUrl (mailNo) {
  let url = {
    // 'development': `https://wx.emspost.com.cn/weixin/ndwz/r/eUzYF3?state=${mailNo}`,
    // 'release': `https://wx.emspost.com.cn/weixin/ndwz/r/eUzYF3?state=${mailNo}`,
    'test': `https://wx.emspost.com.cn/weixin/ndwz/r/eUzYF3?mailNo=${mailNo}`,
    'production': `https://www.emspost.com.cn/dwz/redirect_go.action?sssUrl=qEvIVr&mailNo=${mailNo}`
  }
  return url[NODE_ENV]
}
